<mat-dialog-content class="center-items" align="center">
  <h3 class="clsTitle">{{ data.text }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <div class="row">
    <div class="col-12 text-right">
      <button mat-dialog-close class="clsCardButton cancel-button">
        {{ 'common.no' | translate }}
      </button>
      <button (click)="close()" class="clsCardButton create-button mr-0 ml-0">
        {{ 'common.yes' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
